export default {
  title: 'Site-ul tău este gata',
  body_one: 'Rezervările sunt încă dezactivate pentru {{count}} restaurant:',
  body_few: 'Rezervările sunt încă dezactivate pentru {{count}} restaurante:',
  body_other: 'Rezervările sunt încă dezactivate pentru {{count}} de restaurante:',
  reasons: {
    license_required: 'Necesită un Plan Partner',
    notification_email_required:
      'Este necesară o adresă de e-mail pentru notificările despre rezervări. Adăugați-o când activați rezervările.',
    switched_off: 'Dezactivat în setările de rezervări',
    activation_failed: 'Nu a putut fi activat. Încearcă din nou din setările de rezervări.',
  },
  buttons: {
    open_settings: 'Deschide setările de rezervări',
    continue: 'Continuă la generatorul de site-uri',
  },
};
